import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-presentation-footer',
  templateUrl: './presentation-footer.component.html',
  styleUrls: ['./presentation-footer.component.scss']
})
export class PresentationFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
